import * as React from 'react';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { Opgavepakke } from '../../models/Opgavepakke';
import { Grid, Row, Col, DropdownButtonItem } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { FilterControlsWrapper } from '../../uiComponents/layout/FilterControlsWrapper';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { Loading } from '../../uiComponents/Loading';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import { LinkPrimaryButton, OverflowDropdownButton } from '../../uiComponents/input/Buttons';
import { SkoleaarDropdown } from '../../uiComponents/input/SkoleaarDropDown';
import { getSkoleaarFromDate } from '../../models/SkoleAar';
import Table from '../../uiComponents/table/Table';
import { TableHeaderColumn } from 'react-bootstrap-table';
import Moment from 'react-moment';
import TableFormatters from '../../uiComponents/table/TableFormatters';

export interface OpgavepakkeListProps {
}

export interface OpgavepakkeListState {
    opgavepakker?: Opgavepakke[];
    selectedSkoleaar: number;
}

class OpgavepakkeList extends React.Component<OpgavepakkeListProps, OpgavepakkeListState> {
    constructor(props: OpgavepakkeListProps) {
        super(props);

        this.state = { opgavepakker: undefined, selectedSkoleaar: getSkoleaarFromDate(new Date) };

        this.onFilterChanged = this.onFilterChanged.bind(this);
        this.filter = this.filter.bind(this);
        this.menuFormatter = this.menuFormatter.bind(this);
        this.dateFormatter = this.dateFormatter.bind(this);
    }

    componentDidMount() {
        const self = this;
        createApiCaller().getOpgavepakker().then(response =>
            self.setState({ opgavepakker: response })
        );
    }

    onFilterChanged(fieldName: string, value: string) {
        this.setState({ selectedSkoleaar: +value });
    }

    filter(): Opgavepakke[] {
        if (this.state.opgavepakker === undefined) {
            return [];
        }
        return this.state.opgavepakker.filter(o => o.skoleaar === this.state.selectedSkoleaar);
    }

    menuFormatter(cell: any, row: any) {
        return (
            <OverflowDropdownButton>
                <DropdownButtonItem href={'/opgavepakke/rediger/' + row.id} text='Redigér' />
            </OverflowDropdownButton>
        );
    }

    dateFormatter(cell: any, row: any) {
        return (
            <Moment format='DD.MM.YY'>{cell}</Moment>
        );
    }

    render() {
        let buttons = <LinkPrimaryButton url={'/opgavepakke/ny'} text={'Ny opgavepakke'} />;
        const opgavepakker = this.filter();
        return (
            <PageWrapper>
                <PageTitle title='Opgavepakker' />
                <FilterControlsWrapper>
                    <Grid>
                        <Row>
                            <Col md={3}>
                                <SkoleaarDropdown
                                    onChange={this.onFilterChanged}
                                    selectedValue={this.state.selectedSkoleaar}
                                />
                            </Col>
                        </Row>

                    </Grid>
                </FilterControlsWrapper>
                <ContentWrapper>
                    <Loading isLoading={this.state.opgavepakker === undefined}>
                        <SectionGroup header={'Opgavepakker'} buttons={buttons}>
                            <Section fullWidth={true}>
                                <Table data={opgavepakker} pagination={true} emptyText='Ingen opgavepakker'>
                                    <TableHeaderColumn dataField='id' isKey={true} hidden={true} dataAlign='center' />
                                    <TableHeaderColumn dataField='titel' className='first' columnClassName='first' dataSort={true}>Titel</TableHeaderColumn>                                    
                                    {/* <TableHeaderColumn dataField='skoleaar' dataSort={true}>Skoleår</TableHeaderColumn>                           */}
                                    <TableHeaderColumn dataField='lastChangedDate' dataFormat={TableFormatters.dateDaysFormatter} dataSort={true}>Sidst opdateret</TableHeaderColumn>         
                                    <TableHeaderColumn width='60' dataFormat={this.menuFormatter} className='table-menu' columnClassName='table-menu' />
                                </Table>
                            </Section>
                        </SectionGroup>
                    </Loading>
                </ContentWrapper>
            </PageWrapper>
        );
    }
}

export default OpgavepakkeList;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgavepakke/OpgavepakkeList.tsx